<template>
  <div class="max-w-2xl space-y-4">
    <!-- Page header -->
    <div class="flex items-center gap-3">
      <span class="flex items-center justify-center w-10 h-10 rounded-xl bg-taxiye-100 text-taxiye-500">
        <span class="material-icons-round">confirmation_number</span>
      </span>
      <div>
        <h2 class="text-lg font-semibold text-gray-800">Add Coupon</h2>
        <p class="text-sm text-gray-500">Create a new trip coupon.</p>
      </div>
    </div>

    <form @submit.prevent="addCoupon" class="bg-white border border-gray-200 rounded-2xl shadow-sm">
      <div class="p-6 space-y-5">
        <!-- Title -->
        <div>
          <label class="block text-xs font-semibold tracking-wider text-gray-600 uppercase">Title</label>
          <input
            v-model="coupon.title"
            class="w-full h-10 mt-1.5 text-sm text-gray-800 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
            placeholder="Coupon name"
            required
          />
        </div>

        <!-- Description -->
        <div>
          <label class="block text-xs font-semibold tracking-wider text-gray-600 uppercase">Description</label>
          <input
            v-model="coupon.description"
            class="w-full h-10 mt-1.5 text-sm text-gray-800 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
            placeholder="Description about the coupon"
            required
          />
        </div>

        <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <!-- Amount -->
          <div>
            <label class="block text-xs font-semibold tracking-wider text-gray-600 uppercase">Discount Amount (Br)</label>
            <input
              v-model="coupon.amount"
              class="w-full h-10 mt-1.5 text-sm text-gray-800 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              placeholder="10"
              type="number"
              required
            />
          </div>

          <!-- Prefix -->
          <div>
            <label class="block text-xs font-semibold tracking-wider text-gray-600 uppercase">Prefix (3-letters)</label>
            <input
              v-model="coupon.prefix"
              class="w-full h-10 mt-1.5 font-mono text-sm tracking-widest text-gray-800 uppercase border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              placeholder="ADK"
              maxlength="3"
              required
            />
          </div>
        </div>

        <!-- Number of coupons -->
        <div>
          <label class="block text-xs font-semibold tracking-wider text-gray-600 uppercase">Number of Coupons</label>
          <input
            v-model="coupon.numberOfCoupons"
            class="w-full h-10 mt-1.5 text-sm text-gray-800 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
            placeholder="Number of coupons"
            type="number"
            required
          />
        </div>
      </div>

      <!-- Footer -->
      <div class="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-100 bg-gray-50 rounded-b-2xl">
        <button
          type="button"
          @click="$router.back()"
          class="inline-flex items-center h-10 px-4 text-sm font-semibold text-gray-600 transition-colors duration-150 bg-white border border-gray-300 shadow-sm rounded-xl hover:bg-gray-100"
        >
          Cancel
        </button>
        <button
          type="submit"
          :disabled="loading"
          class="inline-flex items-center h-10 px-4 text-sm font-semibold text-white transition-colors duration-150 shadow-sm rounded-xl bg-taxiye-500 hover:bg-taxiye-600 disabled:opacity-60 disabled:cursor-not-allowed"
        >
          <span v-if="loading" class="mr-1 text-base material-icons-round spin">sync</span>
          <span v-else class="mr-1 text-base material-icons-round">add</span>
          {{ loading ? "Creating..." : "Create Coupon" }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      coupon: {
        title: null,
        description: null,
        amount: null,
        prefix: null,
        numberOfCoupons: null,
      },
      loading: false,
    };
  },
  methods: {
    addCoupon() {
      this.loading = true;
      this.$misc
        .post(`coupons`, {
          ...this.coupon,
        })
        .then(() => {
          window.flash({
            type: "success",
            body: "Coupon added successfully!",
          });
          this.$router.push("/coupons");
        })
        .catch((err) => {
          console.log(err);
          window.flash({
            type: "error",
            body: `Failed. ${err.response.data}`,
          });
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>